import { useState, useEffect } from 'react';
import { getEnumType, EnumType } from '@/api/common';

export default function useGetCommonEnum(enumType: keyof typeof EnumType) {
  const [commonEnum, setCommonEnum] = useState({});
  useEffect(() => {
    if (!enumType) return;
    getEnumType(enumType)
      .then((r) => {
        if (r) {
          setCommonEnum(r?.reduce((pre, current) => {
            // eslint-disable-next-line no-param-reassign
            pre[current?.key] = current.value;
            return pre;
          }, {}));
        } else {
          setCommonEnum({});
        }
      });
  }, [enumType]);
  return [commonEnum];
}
